import { render, staticRenderFns } from "./cooperation-accounts-index.vue?vue&type=template&id=3882c596&scoped=true&"
import script from "./cooperation-accounts-index.vue?vue&type=script&lang=js&"
export * from "./cooperation-accounts-index.vue?vue&type=script&lang=js&"
import style0 from "./cooperation-accounts-index.vue?vue&type=style&index=0&id=3882c596&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3882c596",
  null
  
)

export default component.exports